module.exports = __webpack_public_path__ + "img/hitfm-box.505e5e2e.png";